<template>
    <div class="user">
        <div class="photo">
            <md-icon style="color:white !important; margin-left:5px"
                >language</md-icon
            >
        </div>
        <div class="user-info">
            <a
                data-toggle="collapse"
                :aria-expanded="!isClosed"
                @click.stop="toggleMenu"
                @click.capture="clicked"
            >
                <span>
                    {{ $t("language") }}
                    <b class="caret"></b>
                </span>
            </a>

            <collapse-transition>
                <div v-show="!isClosed">
                    <ul class="nav">
                        <slot>
                            <li
                                v-for="language in languages"
                                v-bind:key="language.key"
                                v-bind:class="{ 'active': language.key == currentLocale, '': language.key != currentLocale }"
                            >
                                <a v-on:click="changeLanguage(language.key)">
                                    <span class="sidebar-mini">{{
                                        $t(language.abreviatura)
                                    }}</span>
                                    <span class="sidebar-normal">{{
                                        $t(language.text)
                                    }}</span>
                                </a>
                            </li>
                        </slot>
                    </ul>
                </div>
            </collapse-transition>
        </div>
    </div>
</template>
<script>
let user = JSON.parse(localStorage.getItem("instantcare_user"));

export default {
    data() {
        return {
            isClosed: true,
            currentLocale: this.$i18n.locale,
            languages: [
                {
                    text: "spanish",
                    key: "es",
                    abreviatura: "ES"
                },
                {
                    text: "english",
                    key: "en",
                    abreviatura: "EN"
                },
                {
                    text: "dutch",
                    key: "nl",
                    abreviatura: "NL"
                }
            ]
        };
    },
    methods: {
        changeLanguage(lang) {
            this.$i18n.locale = lang;
            this.currentLocale = lang;
            localStorage.setItem("locale", lang);
        },
        clicked: function(e) {
            e.preventDefault();
        },
        toggleMenu: function() {
            this.isClosed = !this.isClosed;
        }
    }
};
</script>
<style>
.collapsed {
    transition: opacity 1s;
}

.text-danger {
    color: red !important;
}
</style>
